<template>
	<div v-if="canShow && this.$route.name !== 'order-now-boxes'" >
		<div @click="open()"  class="ico" >
			<v-badge
				v-if="icon"
		        color="#F04844"
		        :content="`${total}`"
		        overlap
		    >
				<span
					big
					icon
				><i class="fas fa-shopping-cart" style='margin: 7px 7px;font-size: 21px'/></span>
		    </v-badge>
		</div>

		<subscribed-bill v-if="bill" ref="bill" v-model="value" :updating.sync="updating"/>
   	</div>
</template>
<script>

import { container } from '../../services/container'
import SubscribedBill from './SubscribedBill'

export default {

	components: {
		SubscribedBill
	},
	props: {
		icon: {
			type: Boolean,
			default: true
		},
		bill: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			value: false,
			updating: false
		}
	},
	computed: {
	    canShow() {
	      return this.order// && (!this.order.date.confirmed_at)
	    },
		total () {
			return this.order ? this.order.countItems() : 0
		},
	    user () {
	      return this.$root.user ? this.$root.user : null
	    },
		order () {
			return this.user ? this.user.order : null
		}
	},
	methods: {
		open() {
			if (this.order) {
				this.value = true
			}
		}
	},
	watch: {
		value: function (value) {

			window.dispatchEvent(new CustomEvent('billing-cart', { 
				bubbles: true, 
				detail: value 
			}));
		}
	},
	mounted() {
		window.addEventListener('billing-cart', (e) => {
			this.value = e.detail;
		});
	}
}
</script>
<style>


	.ico {
		color: var(--quomi-primary);
		border: 1px solid var(--quomi-primary);
		border-radius: 5px;
		padding: 0px 0px;
		cursor:pointer;
	}

	@media(max-width: 1026px) {
		.ico {
			margin: -6px;
			border: none;
		}
	}
</style>